<div *ngIf="info"
	class="information">
	<ng-container *ngIf="!isEdit">
		<div class="information__head">
			<ng-container *appHasAccess="['INFORMATION_EDIT']">
				<button *ngIf="!isEdit"
					(click)="editData()"
					class="btn btn-accent-filter icon">
					<img src="assets/img/white-pen.svg"
						alt="icon"
						class="icon-button">
					{{ "INFORMATION_PAGE.EDIT_BTN" | translate }}
				</button>
			</ng-container>
		</div>
		<div class="information__block">
			<div class="information__block-head">
				<p *ngIf="!info.enabled"
					class="status">
					{{ "INFORMATION_PAGE.UNLOCKED" | translate }}
				</p>
				<p *ngIf="info.enabled"
					class="status blocked">
					{{ "INFORMATION_PAGE.BLOCKED" | translate }}
				</p>
				<div class="info">
					<p class="bin">
						{{ "INFORMATION_PAGE.ID" | translate }} {{ info.agent_id }}
					</p>


					<p class="bin">
						{{ "INFORMATION_PAGE.BIN" | translate }} {{ info.BIN }}
					</p>
				</div>
			</div>
			<h2 class="information__block-name">
				{{ info.agent_name }}
			</h2>
			<div class="information__block-detail">
				<div class="left">
					<p class="name">
						{{ "INFORMATION_PAGE.E_MAIL" | translate }}
					</p>
					<p class="value">{{ info.email }}</p>
				</div>
				<div class="center">
					<p class="name">
						{{ "INFORMATION_PAGE.PHONE" | translate }}
					</p>
					<p class="value">
						{{ info.phone_number }}
					</p>
				</div>
				<div class="right">
					<p class="name">
						{{ "INFORMATION_PAGE.REGISTER" | translate }}
					</p>
					<p class="value">
						{{ info.creation_date }}
					</p>
				</div>
			</div>
			<div class="information__block-detail">
				<div class="left">
					<p class="name">
						{{ "INFORMATION_PAGE.BOOKER" | translate }}
					</p>
					<p class="value">
						{{ info.accountant_name }}
					</p>
				</div>
				<div class="center">
					<p class="name">
						{{ "INFORMATION_PAGE.DIRECTOR" | translate }}
					</p>
					<p class="value">
						{{ info.director_name }}
					</p>
				</div>
				<div class="right">
					<p class="name">
						{{ "INFORMATION_PAGE.METIER" | translate }}
					</p>
					<p class="value">
						{{ info.activity_type }}
					</p>
				</div>
			</div>
		</div>
	</ng-container>


	<ng-container *ngIf="isEdit">
		<form [formGroup]="form"
			(ngSubmit)="sendForm()"
			class="information__block-form">
			<div class="information__head">
				<button *ngIf="isEdit"
					[disabled]="form.invalid"
					type="submit"
					class="btn btn-accent">
					{{ "INFORMATION_PAGE.SAVE_BTN" | translate }}
				</button>
				<button *ngIf="isEdit"
					(click)="isEdit = false"
					type="button"
					class="btn btn-light">
					{{ "INFORMATION_PAGE.CANCEL_BTN" | translate }}
				</button>
			</div>
			<div class="information__block">
				<div class="line">
					<div class="line__left">
						<div [class.error]="
                form.get('nameFormControl')?.invalid &&
                form.get('nameFormControl')?.touched
              "
							class="input-block">
							<input formControlName="nameFormControl"
								id="name"
								class="input"
								type="text"
								placeholder=" ">
							<label for="name"
								class="placeholder">
								{{ "INFORMATION_PAGE.NAME" | translate }}
							</label>
							<ng-container *ngIf="
                  form.get('nameFormControl')?.invalid &&
                  form.get('nameFormControl')?.touched
                ">
								<span *ngIf="nameRequiredError"
									class="input-block__error">
									{{ "INFORMATION_PAGE.NAME_REQUIRED" | translate }}
								</span>
								<span *ngIf="nameFormatError"
									class="input-block__error">
									{{ "INFORMATION_PAGE.NAME_FORMAT_ERROR" | translate }}
								</span>
							</ng-container>
						</div>
					</div>
					<div class="line__right">
						<div [class.error]="
                form.get('binFormControl')?.invalid &&
                form.get('binFormControl')?.touched
              "
							class="input-block">
							<input formControlName="binFormControl"
								mask="000000000000"
								id="bin"
								class="input"
								type="text"
								placeholder=" ">
							<label for="bin"
								class="placeholder">
								{{ "INFORMATION_PAGE.BIN_FORM" | translate }}
							</label>
							<ng-container *ngIf="
                  (form.get('binFormControl')?.invalid &&
                    form.get('binFormControl')?.touched) ||
                  form.get('binFormControl')?.value
                ">
								<span *ngIf="binRequiredError"
									class="input-block__error">
									{{ "INFORMATION_PAGE.BIN_REQUIRED" | translate }}
								</span>
								<span *ngIf="binFormatError && !binRequiredError"
									class="input-block__error">
									{{ "INFORMATION_PAGE.BIN_MIN" | translate }}
								</span>
								<span *ngIf="
                    !binFormatError &&
                    !binRequiredError &&
                    form.get('binFormControl')?.hasError('iinNotValid')
                  "
									class="input-block__error">
									{{ "INFORMATION_PAGE.BIN_INVALID" | translate }}
								</span>
							</ng-container>
						</div>
					</div>
				</div>
				<div class="line">
					<div class="line__left">
						<div [class.error]="
                form.get('emailFormControl')?.invalid &&
                form.get('emailFormControl')?.touched
              "
							class="input-block">
							<input formControlName="emailFormControl"
								id="email"
								class="input"
								type="email"
								placeholder=" ">
							<label for="email"
								class="placeholder">
								{{ "COMPANY_DATA_PAGE.EMAIL" | translate }}
							</label>
							<ng-container *ngIf="
                  form.get('emailFormControl')?.invalid &&
                  form.get('emailFormControl')?.touched
                ">
								<span *ngIf="emailRequiredError"
									class="input-block__error">
									{{ "COMPANY_DATA_PAGE.EMAIL_REQUIRED" | translate }}
								</span>
								<span *ngIf="emailFormatError"
									class="input-block__error">
									{{ "COMPANY_DATA_PAGE.EMAIL_INVALID" | translate }}
								</span>
							</ng-container>
						</div>
					</div>
					<div class="line__right">
						<div [class.error]="
                form.get('phoneFormControl')?.invalid &&
                form.get('phoneFormControl')?.touched
              "
							class="input-block">
							<input formControlName="phoneFormControl"
								id="phone"
								mask="+0 000 000-00-00"
								inputmode="numeric"
								class="input"
								type="text"
								placeholder=" ">
							<label for="phone"
								class="placeholder">
								Номер телефона*
							</label>
							<ng-container *ngIf="
                  form.get('phoneFormControl')?.invalid &&
                  form.get('phoneFormControl')?.touched
                ">
								<span *ngIf="phoneRequiredError"
									class="input-block__error">
									{{ "COMPANY_DATA_PAGE.PHONE_REQUIRED" | translate }}
								</span>
								<span *ngIf="phoneFormatError"
									class="input-block__error">
									{{ "COMPANY_DATA_PAGE.PHONE_INVALID" | translate }}
								</span>
							</ng-container>
						</div>
					</div>
				</div>
				<div class="line">
					<div class="line__left">
						<div [class.error]="
                form.get('directorNameFormControl')?.invalid &&
                form.get('directorNameFormControl')?.touched
              "
							class="input-block">
							<input formControlName="directorNameFormControl"
								id="director"
								class="input"
								type="text"
								placeholder=" ">
							<label for="director"
								class="placeholder">
								{{ "INFORMATION_PAGE.DIRECTOR_NAME" | translate }}
							</label>
							<ng-container *ngIf="
                  form.get('directorNameFormControl')?.invalid &&
                  form.get('directorNameFormControl')?.touched
                ">
								<span *ngIf="directorNameRequiredError"
									class="input-block__error">
									{{ "INFORMATION_PAGE.DIRECTOR_NAME_REQUIRED" | translate }}
								</span>
							</ng-container>
						</div>
					</div>
					<div class="line__right">
						<div class="input-block">
							<input formControlName="bookerNameFormControl"
								id="booker"
								class="input"
								type="text"
								placeholder=" ">
							<label for="booker"
								class="placeholder">
								{{ "INFORMATION_PAGE.BOOKER_NAME" | translate }}
							</label>
						</div>
					</div>
				</div>
				<div class="line">
					<div class="line__left">
						<div [class.error]="
                form.get('metierFormControl')?.invalid &&
                form.get('metierFormControl')?.touched
              "
							class="input-block">
							<input formControlName="metierFormControl"
								id="metier"
								class="input"
								type="text"
								placeholder=" ">
							<label for="metier"
								class="placeholder">
								{{ "INFORMATION_PAGE.METIER_NAME" | translate }}
							</label>
							<ng-container *ngIf="
                  form.get('metierFormControl')?.invalid &&
                  form.get('metierFormControl')?.touched
                ">
								<span *ngIf="metierRequiredError"
									class="input-block__error">
									{{ "INFORMATION_PAGE.METIER_NAME_REQUIRED" | translate }}
								</span>
							</ng-container>
						</div>
					</div>


					<div class="line__right">
						<div class="input-block">
							<input formControlName="agentIdFormControl"
								id="agentId"
								class="input"
								type="text"
								placeholder=" ">
							<label for="agentId"
								class="placeholder">
								{{ "INFORMATION_PAGE.AGENT_CLIENT_ID" | translate }}
							</label>
						</div>
					</div>
				</div>
			</div>
		</form>
	</ng-container>
</div>
